(function($) {
    $(document).on("click", ".yt-video-thumb", function() {
        let title = $(this).attr("alt");
        let src = $(this).attr("data-video");
        console.log("test", $(this));
        $(this).parents(".video").html(`<iframe title="${title}" loading="lazy" class="embed-responsive-item" src="${src}" frameborder="0" allowfullscreen></iframe>`);
    });
})(jQuery);